<script>
import RecommendationCard from '@/components/recommendation/RecommendationCard.vue'
//import 'swiper/swiper-bundle.css'
export default {
  components: {
    RecommendationCard,
  },
  props: {
    recommendation: {
      type: Array,
      default() {
        return [];
      },
    },
    title: String
  },
  data() {
    return {
      dataArray: [
        {
          name: 'Dr. Panda Restaurant 3',
          info: "Be the world's best chef as you get cooking, serve delicious…",
          cover: 'game-cover-3@2x.jpg',
          logo: 'Icon_BigCorner_2@2x.png',
        },
        {
          name: 'Hoopa City 2',
          info: 'Create a thriving metropolis with sky-high apartments and…',
          cover: 'game-cover-4@2x.jpg',
          logo: 'Icon_BigCorner_3@2x.png',
        },
        {
          name: 'Dr. Panda Swimming Pool',
          info:
            'Get ready to have a splashing good time at the swimming pool with…',
          cover: 'game-cover-5@2x.jpg',
          logo: 'Icon_BigCorner_4@2x.png',
        },
        
      ],
      sliderOptions: {
        slidesPerView: 3,
        spaceBetween: 30,
        grabCursor: true,
        slidesPerGroup: 1,
        centeredSlides: false,
        breakpoints: {
           
          992: {
            slidesPerView: 2,
            spaceBetween: 30,
            centeredSlides: false,
            width: 730,
          },
          768: {
            slidesPerView: 2,
            spaceBetween: 20,
            centeredSlides: false,
            width: 600,
          },
          600: {
            slidesPerView: 1,
            spaceBetween: 0,
            centeredSlides: true,
            width: 400,
          },
          400: {
            slidesPerView: 1,
            spaceBetween: 0,
            width: 320,
          },
          320: {
            slidesPerView: 1,
            spaceBetween: 0,
            centeredSlides: false,
            width: 290,
          },
        },
      },
    }
  },
}
</script>

<template>
  <div :class="$style.recommendation" class="w-100 d-inline-block">
    <b-container fluid="md" class="container-mobile-none">
      <h2 class="heading-2 text-center">
        <span v-if="title">{{title}}</span>
        <span v-else>{{ $t("recommendations.interst") }}</span>
      </h2>
      <div :class="$style.recommendationBlock">
        <Swiper
          class="swiper"
          ref="mySwiper"
          :options="sliderOptions"
        >
          <SwiperSlide v-for="(data, index) in recommendation" :key="index">
            <div :class="$style.recCard">
              <RecommendationCard :data="data" />
            </div>
          </SwiperSlide>
        </Swiper>
      </div>
    </b-container>
  </div>
</template>

<style lang="scss" module>
@import "@/design/index.scss";


.recommendation {
  padding: 30px 0 0;
  background-color: $offWhite;
  h2 {
    margin-bottom: 40px;
  }
}
.recommendationBlock {
}
@media only screen and (max-width: 767px) {
  .recCard{
    margin-left: 20px;
  }
}
</style>
